
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";

import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";

@Component({
  components: {
    S3Image,
  }
})
export default class ItemChip extends Vue {
  @Prop({ type: [String, Number], default: undefined }) readonly itemId?: string | number;
  @Prop({ type: String, required: true }) readonly itemName!: string;
  @Prop({ type: [String, Number], default: undefined }) readonly itemExtra?: string | number;
  @Prop({ type: String, default: undefined }) readonly avatar?: string;
  @Prop({ type: String, default: undefined }) readonly routeName?: RouteNames;
  @Prop({ type: Boolean, default: false }) readonly isPerson!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showPointer!: boolean;
  @Prop({ type: String, default: undefined }) readonly maxChipWidth?: string;
  @Prop({ type: Object, default: () => ({}) }) readonly routeParams!: Partial<RouteParams<{ id: string }>>;
  @Prop({ type: Boolean, default: false }) readonly removed!: boolean;
  @Prop({ type: String, default: undefined }) readonly textClasses?: string;
  @Prop({ type: Boolean, default: false }) readonly single!: boolean;
  @Prop({ type: Boolean, default: false, required: false }) readonly management!: boolean;
  @Prop({ type: String, default: '', required: false }) readonly chipClass!: string;

  get containerClasses(): Record<string, boolean> {
    return {
      ["mb-0.5"]: !this.single,
      [this.chipWidth]: Boolean(this.chipWidth)
    };
  }

  get textStyles(): Record<string, boolean> {
    return {
      [String(this.textClasses)]: Boolean(this.textClasses),
      ["text-sm"]: !Boolean(this.textClasses),

    };
  }

  get blockIndentationClasses(): Record<string, boolean> {
    return {
      "pl-1": !this.shouldDisplayAvatar && !this.shouldDisplayAvatarPlaceholder,
    };
  }

  get isLink(): boolean {
    return (!!this.routeName || !!this.routeParams.name) && !!this.itemId;
  }

  get removedTextClasses(): Record<string, boolean> {
    return {
      "border-red-500 text-red-300 hover:text-red-500 hover:border-red-500 rounded-full": this.removed,
      "border-gray-300 text-gray-500 hover:text-primary-500 hover:border-primary-500": !this.removed,
    };
  }

  get imageContainerClasses(): Record<string, boolean> {
    return {
      ["cursor-pointer"]: this.showPointer,
      ["cursor-default"]: !this.showPointer,
      ["bg-greenChip text-lightGreen"]: this.management,
      ["bg-lightBlue text-darkBlue"]: !this.management,
            [this.chipClass]: true
    };
  }

  get indentationClasses(): Record<string, boolean> {
    return {
      ["mb-1 mr-1"]: !this.single,
    };
  }

  get chipWidth(): string {
    if (this.maxChipWidth) {
      return this.maxChipWidth;
    }

    return "maxChipWidth";
  }

  get shouldDisplayAvatar(): boolean {
    return this.isPerson && Boolean(this.avatar);
  }

  get shouldDisplayAvatarPlaceholder(): boolean {
    return this.isPerson && !this.avatar;
  }

  get routeLinkParams(): RouteParams<{ id: string }> {
    if (this.routeParams.name) {
      return this.routeParams as RouteParams<{ id: string }>;
    }

    return {
      name: this.routeName!,
      params: { id: String(this.itemId) },
    };
  }

  get initial(): string {
    return this.itemName.trim().toUpperCase()[0];
  }
}
